<template>
  <div class="product-sizes-and-measurements-table">
    <table>
      <thead>
        <tr>
          <th
            v-for="(column, key, index) in tableHeaders"
            :key="column[key]"
          >
            {{ column }}{{ index && showHeadingAsterisks > 0 ? '*' : '' }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in tableBody"
          :key="row[index]"
          :class="{ 'tr-colored': index % 2 !== 0 }"
        >
          <td
            v-for="(column, tdIndex) in row"
            :key="column[tdIndex]"
          >
            {{ column }}
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-if="showReference"
      class="psamt-reference"
    >
      {{ $t('product.sizesAndMeasurements.modal.measurementTableReference') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputTable: {
      type: Array,
      default: () => {},
    },
    showReference: {
      type: Boolean,
    },
    showHeadingAsterisks: {
      type: Boolean,
    },
  },
  computed: {
    tableHeaders() {
      if (!this.inputTable) {
        return {};
      }
      const table = { ...this.inputTable[0] } || {};
      return table;
    },

    tableBody() {
      if (!this.inputTable) {
        return [];
      }

      let table = [];

      try {
        table = JSON.parse(JSON.stringify(this.inputTable));
        table.shift();
      } catch (error) {
        this.$log.error('Error occurred while JSON.parse()', error);
      }

      return table;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-sizes-and-measurements-table {
  display: flex;
  flex-direction: column;

  table {
    width: 100%;
    table-layout: fixed;

    @include bp(m, max) {
      width: 99%;
    }

    .tr-colored {
      td {
        background-color: palette(grey, lighter);
      }
    }

    th,
    td {
      border: 1px solid $color-white;
      text-align: center;
    }

    th {
      padding: math.div($pad, 4);
      font-size: map-get($font-sizes, s);
      background-color: palette(grey, pale);
      font-weight: map-get($font-weights, bold);
    }

    td {
      padding: 0.3125 * $pad;
      font-size: map-get($font-sizes, m);
      background-color: $color-general-background-neutral-default;
      font-weight: map-get($font-weights, medium);
    }
  }

  .psamt-reference {
    margin-top: $pad;
    font-size: map-get($font-sizes, s);
    color: palette(content, secondary);

    @include bp(m) {
      align-self: flex-end;
    }
  }
}
</style>
